'use client'

import { memo } from 'react'
import { PhoneOff } from 'lucide-react'
import { BaseNode } from './BaseNode'

interface HangupNodeProps {
  selected?: boolean
}

function HangupNodeComponent({ selected }: HangupNodeProps) {
  return (
    <BaseNode
      icon={<PhoneOff className="w-4 h-4" />}
      label="Hangup"
      selected={selected}
      hasOutputHandle={false}
      className="border-red-500/50 bg-red-50/50 dark:bg-red-950/20"
    >
      <p className="text-xs text-muted-foreground">
        End the call
      </p>
    </BaseNode>
  )
}

export const HangupNode = memo(HangupNodeComponent)
